<div class="settings-page">
    <div class="settings-page__content">
        <div class="settings-card">
            <div class="settings-card__header">
                <img src="/assets/images/Group 24.svg" alt="" />
                <div class="settings-card__header-headline">
                    <h2>Bine ați venit!</h2>
                    <h4>Setări - Programări</h4>
                </div>
            </div>
        </div>
    </div>

    <div class="content-box">
        <div class="settings-page-container">
            <mat-button-toggle-group [value]="selectedComponent" (change)="onChange($event)" class="settings-page_menu">
                <mat-button-toggle [value]="option" class="settings-page_menu-item"
                    *ngFor="let option of componentKeys">
                    <div style="text-align: left;">
                        {{ option }}
                    </div>
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <div class="settings-page__content">
            <ng-container *ngIf="selectedComponent === SettingsActivitiesProgOption.MODULE">
                <app-modul> </app-modul>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesProgOption.LOCATII">
                <app-locatii></app-locatii>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesProgOption.ZILE_LIBERE">
                <app-zile-libere> </app-zile-libere>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesProgOption.SPECIALIZARI">
                <app-specializari></app-specializari>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesProgOption.STATUSURI">
                <app-status> </app-status>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesProgOption.PRIORITATI">
                <app-prioritati></app-prioritati>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesProgOption.OPERATORI">
                <app-operatori></app-operatori>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesProgOption.TIPURI_PROBLEME">
                <app-tipuri-probleme></app-tipuri-probleme>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesProgOption.PROGRAM">
                <app-program></app-program>
            </ng-container>
            <div class="row" *ngIf="selectedComponent == null">
                <div class="col-sm-12 py-5">
                    <div class="row h-100 justify-content-center align-items-center">
                        <div class="col-12 text-center">
                            <div class="py-3">
                                <p class="mb-0">Selectați o secțiune</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>